import { IntlShape } from "react-intl";
import { TFunction } from "i18next";
import { toTitleCase } from "@/utils/helpers";
import { TableColumnHeader } from "@/components/shared/table/Table";
import { HierarchySheetComponent } from "./Components/HierarchySheetComponent";
import { Badge } from "@/components/ui/badge";

/**
 * Generates column definitions for the organizations table.
 *
 * @param intl - Internationalization object for formatting
 * @param t - Translation function
 * @returns Array of column definitions for the DataTable
 */
export const getColumnsOrganizations = (intl: IntlShape, t: TFunction) => {
  return [
    {
      accessorKey: "name",
      header: ({ column }) => (
        <TableColumnHeader
          text={t("tables:organizations.columns.name")}
          column={column}
        />
      ),
      cell: ({ row }) => toTitleCase(row.original.name),
    },
    {
      accessorKey: "shortName",
      header: ({ column }) => (
        <TableColumnHeader
          text={t("tables:organizations.columns.shortname")}
          column={column}
        />
      ),
      cell: ({ row }) => row.original.shortName ?? "",
    },
    {
      accessorKey: "province",
      header: ({ column }) => (
        <TableColumnHeader
          text={t("tables:organizations.columns.province")}
          column={column}
        />
      ),
      cell: ({ row }) => row.original.province ?? "",
    },
    {
      // Combined column: if there are children, show hierarchy; if not, show operational badge
      accessorKey: "isOperationalOrChildren",
      header: () => null,
      cell: ({ row }) => {
        const children = row.original.children;

        if (Array.isArray(children) && children.length > 0) {
          return <HierarchySheetComponent org={row.original} />;
        }

        // Only show operational badge if the organization is operational
        if (row.original.isOperational) {
          return <Badge>{t("translation:adminorganization.operational")}</Badge>;
        } else {
          return null;
        }
      },
    }
  ];
};
